import { mapStyle } from '@bikemap/js/api'
import { MapStyleControl } from '../controls'
import MapFeature from './MapFeature'

/**
 * Show a map style control to switch between our styles.
 */
export default class MapStyleSelection extends MapFeature {

    /** @type {import('@bikemap/js/api/services/MapStyleApiService').MapStyle[]} */
    _mapStyles

    /** @type {MapStyleControl} */
    _control

    constructor() {
        super()

        this._control = new MapStyleControl({
            onSelect: this._handleMapStyleSelect.bind(this),
        })

        this._fetchMapStyles()
    }

    _onAdd(map) {
        map.addControl(this._control, 'top-right')
    }

    _onRemove(map) {
        map.removeControl(this._control)
    }

    /**
     * Fetch list of map styles from API and update control.
     */
    async _fetchMapStyles() {
        const mapStyles = await mapStyle.list()
        this._control.setMapStyles(mapStyles)
    }

    /**
     * @param {Object} style
     */
    _handleMapStyleSelect(style) {
        this._control.setMapStyle(style)
        this._map.setStyle(style.url)
    }

}
